import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DtnService {
  private readonly baseUrl = environment.apiBaseUrl;
  constructor(private http: HttpClient) {}

  /** Fetch new DTN token */
  getToken() {
   const url = `${this.baseUrl}/scperformance/get-map-token`;
  return this.http.get<any>(url).pipe(catchError(this.errorHandler));
  }

  /** Fetch latest DTN API quota usage (used/limit per account+product) */
  getQuotaUsage() {
    const url = `${this.baseUrl}/scperformance/dtn-quota-usage`;
    return this.http.get<any[]>(url).pipe(catchError(this.errorHandler));
  }

  /** Trigger a live re-scrape of DTN quota usage (logs into devportal.dtn.com) */
  refreshQuotaUsage() {
    const url = `${this.baseUrl}/scperformance/dtn-quota-usage/refresh`;
    return this.http.post<any>(url, {}).pipe(catchError(this.errorHandler));
  }

  /** Fetch per-day DTN usage deltas (derived from consecutive daily scrapes) */
  getDailyQuotaUsage() {
    const url = `${this.baseUrl}/scperformance/dtn-quota-usage/daily`;
    return this.http.get<any[]>(url).pipe(catchError(this.errorHandler));
  }
  getLatestTileSetId(layerId: string, token: string) {
    const url = `https://map.api.dtn.com/v2/timestamps/${layerId}?unit=metric`;

    // ✅ ensure token has no whitespace
    const cleanToken = token.trim();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${cleanToken}`,
    });

    return this.http.get<any>(url, { headers }).pipe(
      map((res) => {
        // depends on API structure, check res.data or res.timestamps
        const latest = res?.[0].timestamps[0].tileSetId;
        return latest;
      })
    );
  }

   errorHandler(error: HttpErrorResponse) {
      return throwError(() => error || 'Server Error');
    }
}
